const CuppSchema = {
    type: 'UsageEventType',
    timeTaken: 'UsageTimeTaken',
    eventName: 'UsageEventName',
    feature: 'UsageCapabilityName',
    subFeature: 'UsageSubCapabilityName',
    subFeatureLevel2: 'UsageSubCapabilityLevel2',
    featureLocation: 'UsageLocation',
    businessTransactionId: 'UsageBusinessTransactionId',
    experienceResult: 'UsageExperienceResult',
    usageUserId: 'UsageUserId',
    sessionId: 'UsageSessionId',
    actionTrackingId: 'UsageActionTrackingId',
    correlationTrackingId: 'UsagecCorrelationTrackingId',
    pageTrackingId: 'UsagePageTrackingId',
    eventDate: 'UsageEventDate',
    flightId: 'UsageFlightId',
    flightName: 'UsageFlightName',
    moduleName: 'UsageModuleName',
    usageVersion: 'UsageVersion',
};
export const asCuppSchema = (props) => Object.keys(props).reduce((acc, key) => (Object.assign(Object.assign({}, acc), {
    [CuppSchema[key] || key]: props[key] instanceof Date
        ? props[key].toISOString()
        : props[key] !== undefined
            ? props[key]
            : '',
})), {});
//# sourceMappingURL=CuppSchemaMapper.js.map